import Axios from "axios"
import { errorHandler, generateRequestHeaders } from "../../utils"
import api from '../../api'
import { TIMEOUT } from "../../constants"

const service = {
  // GET single program by id
  async getData(id) {
    return new Promise(function(resolve, reject){
      const config = {
        timeout: TIMEOUT,
        headers: generateRequestHeaders()
      }

      Axios.get(`${api.base}${api.programs}${id}/`, config).then(res => {
        if(res.data){
          if(res.data.results){
            resolve(res.data.results)
          } else {
            resolve(res.data)
          }
        }else{
          resolve(res)
        }
      }).catch(err => {
        const message = errorHandler(err)
        reject(message)
      })
    })
  },

  async delete(id){
    return new Promise(function(resolve, reject){
      const config = {
        headers: generateRequestHeaders()
      }

      if(id){
        Axios.delete(`${api.base}${api.programs}${id}/`, config)
        .then(res => {
          if(res.data){
            resolve(res.data)
          }else{
            resolve(res)
          }
        })
        .catch(err => {
          const message = errorHandler(err)
          reject(message)
        });
      } else {
        reject('id not provided.')
      }
    })
  },
}

export default service
